import { MUNICIPAL_PROPERTY_MASTER_DATA_BOUNDS } from "@ark/shared";
export function resolveNextEditableYear(effectiveYearList: readonly number[]): number {
  const currentYear: number = new Date().getFullYear();
  const nextStoredYear: number = effectiveYearList.reduce(
    (nextYear: number, year: number): number => Math.max(nextYear, year + 1),
    currentYear,
  );
  return Math.min(MUNICIPAL_PROPERTY_MASTER_DATA_BOUNDS.maxEffectiveYear, nextStoredYear);
}
